/**
 * Helpers for storing the local participant's `handRaised` flag inside their
 * LiveKit `metadata` JSON. The server stores `metadata` as an opaque string per
 * participant; we use a small object so future flags (DND, recording opt-out,
 * …) can live alongside hand-raise without colliding.
 */

export interface ParticipantMetadata {
  handRaised?: boolean;
  [key: string]: unknown;
}

export function parseMetadata(raw: string | undefined): ParticipantMetadata {
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw) as unknown;
    if (parsed && typeof parsed === "object") {
      return parsed as ParticipantMetadata;
    }
  } catch {
    // Some older clients may have written plain strings; treat as empty rather
    // than spamming the console.
  }
  return {};
}

export function parseHandRaised(raw: string | undefined): boolean {
  return parseMetadata(raw).handRaised === true;
}

export function withHandRaised(
  raw: string | undefined,
  handRaised: boolean,
): string {
  const next = { ...parseMetadata(raw), handRaised };
  return JSON.stringify(next);
}
